module.exports = __webpack_public_path__ + "img/bienvenida.6e659f3e.svg";